import React from 'react';

// Section divider — a central Elven star flanked by two lesser stars, strung
// on a hairline that fades at both ends. Echoes the crowning-star motif of
// the White-Tree mark.
export function Ornament() {
  return (
    <div className="ornament" aria-hidden="true">
      <span className="ornament__line" />
      <svg width="7" height="7" viewBox="0 0 14 14" fill="currentColor" opacity={0.5}>
        <path d="M7 1 L8 6 L13 7 L8 8 L7 13 L6 8 L1 7 L6 6 Z" />
      </svg>
      <svg className="ornament__star" width="16" height="16" viewBox="0 0 14 14" fill="currentColor">
        <path d="M7 0 L8 6 L14 7 L8 8 L7 14 L6 8 L0 7 L6 6 Z" />
      </svg>
      <svg width="7" height="7" viewBox="0 0 14 14" fill="currentColor" opacity={0.5}>
        <path d="M7 1 L8 6 L13 7 L8 8 L7 13 L6 8 L1 7 L6 6 Z" />
      </svg>
      <span className="ornament__line" />
    </div>
  );
}
